import React, { useContext, useEffect, useState } from "react";
import {
  Cesium1Set,
  Ratio1Set,
  Ratio2Set,
  RendouSet,
  Rotate1Set,
  Rotate2Set,
  SyukurenSet,
} from "../App";

export const ButtonRatio = () => {
  const { rendouset, setRendouSet } = useContext(RendouSet);
  const { setSyukurenSet } = useContext(SyukurenSet);
  const { cesium1set } = useContext(Cesium1Set);

  const { ratio1set, setRatio1Set } = useContext(Ratio1Set);
  const { rotate1set, setRotate1Set } = useContext(Rotate1Set);
  const { ratio2set, setRatio2Set } = useContext(Ratio2Set);
  const { rotate2set, setRotate2Set } = useContext(Rotate2Set);
  const ratioset = [0.05, 0.1, 0.5, 1, 2, 5, 10];
  const [count, setCount] = useState(Number(3));
  const [position, setPosition] = useState();

  const increment = () => {
    // setRotate1Set(false);
    // setRotate2Set(false);
    setCount((prevCount) => prevCount + 1);
  };
  const decrement = () => {
    // setRotate1Set(false);
    // setRotate2Set(false);
    setCount((prevCount) => prevCount - 1);
  };

  useEffect(() => {
    setRatio1Set(ratioset[count]);
    setRatio2Set(ratioset[count]);
  }, [count]);

  return (
    <>
      <div
        className="flex justify-center md:rounded-xl bg-gray-200 p-1 md:py-1"
        x-data="app"
      >
        <div className="px-0 md:px-1 py-0 md:py-1 text-center text-xs md:text-sm lg:text-base">
          {count >= 6 && (
            <div className="block mx-auto w-12 cursor-pointer select-none md:rounded-xl px-0 md:px-1 py-0 md:py-1 text-center text-xs md:text-sm lg:text-base bg-blue-200 text-white">
              +
            </div>
          )}
          {count < 6 && (
            <div
              onClick={increment}
              className="block mx-auto w-12 cursor-pointer select-none md:rounded-xl px-0 md:px-1 py-0 md:py-1 text-center text-xs md:text-sm lg:text-base bg-blue-500 text-white"
            >
              +
            </div>
          )}
          <div className="md:my-2 text-sm md:text-base lg:text-xl">
            <h1>{ratioset[count]}倍</h1>
          </div>
          {count > 0 && (
            <div
              onClick={decrement}
              className="block mx-auto w-12 cursor-pointer select-none md:rounded-xl px-0 md:px-1 py-0 md:py-1 text-center text-xs md:text-sm lg:text-base bg-blue-500 text-white"
            >
              -
            </div>
          )}
          {count <= 0 && (
            <div className="block mx-auto w-12 cursor-pointer select-none md:rounded-xl px-0 md:px-1 py-0 md:py-1 text-center text-xs md:text-sm lg:text-base bg-blue-200 text-white">
              -
            </div>
          )}
        </div>
      </div>
    </>
  );
};
